import React from "react";
import { ParallaxLayer } from "@react-spring/parallax";
import { getLayerSpeed, getLayerOffset } from "./IntegrationsLayerSpeeds";

import HazeBackground from "../../../assets/integrations/HazeBackground.webp";
import PinkHaze from "../../../assets/integrations/PinkHaze.webp";
import HazeGroup from "../../../assets/integrations/HazeGroup.webp";
import StarsNebula from "../../../assets/integrations/Stars.webp";
import Stars from "../../../assets/info/Stars.webp";
import Cloud1 from "../../../assets/integrations/Cloud1.webp";
import Cloud2 from "../../../assets/integrations/Cloud2.webp";
import Mountain from "../../../assets/integrations/Mountain.webp";

interface LayersProps {
	offset: number;
}

export const IntegrationLayers: React.FC<LayersProps> = ({ offset }) => (
	<>
		<ParallaxLayer
			offset={0}
			style={{ zIndex: 1 }}
		>
			<div className="integrations-haze-background">
				<img
					src={HazeBackground}
					alt="Haze BG"
				/>
			</div>
			<div className="integrations-haze-pink">
				<img
					src={PinkHaze}
					alt="Pink Haze"
				/>
			</div>
		</ParallaxLayer>

		<ParallaxLayer
			offset={0}
			style={{ zIndex: 2 }}
		>
			<div className="integrations-haze-group">
				<img
					src={HazeGroup}
					alt="Haze Group"
				/>
			</div>
		</ParallaxLayer>

		<ParallaxLayer
			offset={getLayerOffset("starsNebula", offset)}
			speed={getLayerSpeed("starsNebula")}
			style={{ zIndex: 3 }}
		>
			<div className="integrations-stars-nebula">
				<img
					src={StarsNebula}
					alt="Stars Nebula"
				/>
			</div>
		</ParallaxLayer>

		<ParallaxLayer
			offset={getLayerOffset("stars", offset)}
			speed={getLayerSpeed("stars")}
			style={{ zIndex: 4 }}
		>
			<div className="integrations-stars">
				<img
					src={Stars}
					alt="Stars"
				/>
			</div>
		</ParallaxLayer>

		<ParallaxLayer
			offset={0}
			style={{ zIndex: 5 }}
		>
			<div className="integrations-cloud-1">
				<img
					src={Cloud1}
					alt="Cloud 1"
				/>
			</div>
			<div className="integrations-cloud-2">
				<img
					src={Cloud2}
					alt="Cloud 2"
				/>
			</div>
		</ParallaxLayer>

		<ParallaxLayer
			offset={0}
			style={{ zIndex: 6 }}
		>
			<div className="integrations-mountain">
				<img
					src={Mountain}
					alt="Mountain"
				/>
			</div>
		</ParallaxLayer>
	</>
);
